import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { useIsPresent } from 'motion/react';

import { SHARED_ROUTES } from '@/routes';
import { RootState } from '@/types/graph';

import { RedirectOnce } from './RedirectOnce';

/**
 * The patient-data pages save to the selected patient: without one (e.g. a
 * page opened by URL), identify the patient first. The copy of the page that
 * AnimatedOutlet keeps mounted while it animates out must not redirect again.
 */
export const RequirePatient = () => {
  const hasPatient = useSelector(
    (state: RootState) => !!state.consultation.patient?.id,
  );
  const isPresent = useIsPresent();

  if (hasPatient) return <Outlet />;
  return isPresent ? (
    <RedirectOnce to={SHARED_ROUTES.PATIENT_INFORMATION} />
  ) : null;
};
